export default __webpack_public_path__ + "static/media/HSMJAVA.e62182eb.png";